import React from 'react';

function PersonSelect({ persons, value, onChange, label, single }) {
  return (
    <div>
      <label>{label}:</label>
      {single ? (
        <select value={value} onChange={e => onChange(Number(e.target.value))} required>
          <option value="">Bitte wählen</option>
          {persons.map(person => (
            <option key={person.id} value={person.id}>{person.name}</option>
          ))}
        </select>
      ) : (
        <select multiple value={value} onChange={e => {
          const selected = Array.from(e.target.selectedOptions, opt => Number(opt.value));
          onChange(selected);
        }}>
          {persons.map(person => (
            <option key={person.id} value={person.id}>{person.name}</option>
          ))}
        </select>
      )}
    </div>
  );
}

export default PersonSelect;

